import { render, staticRenderFns } from "./TourVirtual.vue?vue&type=template&id=eb99efde&"
import script from "./TourVirtual.vue?vue&type=script&lang=js&"
export * from "./TourVirtual.vue?vue&type=script&lang=js&"
import style0 from "./TourVirtual.vue?vue&type=style&index=0&id=eb99efde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports